import React from 'react';
import { NonceProvider } from 'react-select';
import AsyncSelect from "react-select/async"

export * from 'react-select/async';

export default class NoncedAsyncSelect extends React.Component {
  render() {
    const cspNonce = document.querySelector("meta[name=csp-nonce]")?.content;

    return (
      <NonceProvider cacheKey="react-select-style-cache" nonce={cspNonce}>
        <AsyncSelect {...this.props}>
          {this.children}
        </AsyncSelect>
      </NonceProvider>
    );
  }
}

NoncedAsyncSelect.propTypes = AsyncSelect.propTypes;